<template lang="html">
    <main>
        <AssetFeed/>
    </main>
</template>

<script>
    import AssetFeed from '../components/AssetFeed.vue'

    export default {
        name: 'home',
        components: {
            AssetFeed
        },
        data: () => ({
            bio: {
                name: 'Lebron james',
                birthdate: '04161984'
            }
        })
    }
</script>

<style lang="css">
</style>
